<template>
    <div class="diaryRow-item" align="center">
      <column-wrapper> <first-course ref="firstCourse" :student="student" :title="'1er Plato'" :studentName="studentName" @updatedElement="detectElementChange" /> </column-wrapper>
      <column-wrapper> <second-course ref="secondCourse" :student="student" :title="'2º Plato'" :studentName="studentName" @updatedElement="detectElementChange" /> </column-wrapper>
      <column-wrapper> <desserts ref="dessert" :student="student" :title="'Postre'" :studentName="studentName" @updatedElement="detectElementChange" /> </column-wrapper>
      <column-wrapper> <suggested-dinner ref="suggestedDinner" :student="student" :title="'Cena Sugerida'" :studentName="studentName" @updatedElement="detectElementChange" /> </column-wrapper>
    </div>
</template>
<style scope>
.row{
  flex-wrap: nowrap;
}
</style>
<script>
import Desserts from '@/components/menuElements/Desserts.vue'
import FirstCourse from '@/components/menuElements/FirstCourse.vue'
import SecondCourse from '@/components/menuElements/SecondCourse.vue'
import SuggestedDinner from '@/components/menuElements/SuggestedDinner.vue'
import ColumnWrapper from '@/components/Elements/ColumnWrapper.vue'
export default {
  components: {
    Desserts,
    FirstCourse,
    SecondCourse,
    ColumnWrapper,
    SuggestedDinner
  },
  props: {
    id: String,
    studentName: String
  },
  created: function () {
    this.student = this.$attrs.student
  },
  data: () => ({
    student: {}
    // students: []
  }),
  methods: {
    detectElementChange: function (item) {
      this.student = { ...this.student, ...item }
      console.log({detectElementChange: item})
      this.$emit('updatedStudent',
        { id: this.id, data: this.student }
      )
    },
    updateColumn: function (column) {
      const key = Object.keys(column)[0]
      if (this.$refs[key]) this.$refs[key].setValue(column[key])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryType/MenuDiary/MenuDiaryRow.vue